module.exports = __webpack_public_path__ + "img/组 3.f0bc81e1.webp";